import { render, staticRenderFns } from "./LogsForm.vue?vue&type=template&id=391ee34d"
import script from "./LogsForm.vue?vue&type=script&lang=js"
export * from "./LogsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports